import { IPaginationReturn } from '../../interfaces/IPaginationReturn';
import { useRequest } from '../providers/useRequest';
import AppError from '../../errors/AppError';
import ILocal from '../../interfaces/ILocal';

export interface IFilterLocal {
  id?: number | null;
}

const useLocalService = () => {
  const Subsidiary = useRequest<ILocal>();
  const path = 'employee/local';

  const list = async (
    perPage: number,
    currentPage: number,
    orderField: string,
    direction: 'asc' | 'desc',
    filter?: IFilterLocal,
  ): Promise<IPaginationReturn<ILocal[]>> => {
    return await Subsidiary.postAndGetManyPaginated({
      path: `${path}/list?perPage=${perPage}&currentPage=${currentPage}&orderBy=${orderField}&orderDirection=${direction}`,
      sendAuthorization: true,
      body: { ...filter },
    })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const findById = async (id: number): Promise<ILocal> => {
    return await Subsidiary.getOne({
      path: `${path}/${id}`,
      sendAuthorization: true,
    })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const listLocalByName = async (name: string): Promise<ILocal[]> => {
    return await Subsidiary.getMany({
      path: `${path}/findByName/${name}`,
      sendAuthorization: true,
    })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const listLocalBySubsidiaryId = async (id: number): Promise<ILocal[]> => {
    return await Subsidiary.getMany({
      path: `${path}/ListBySubsidiaryId/${id}`,
      sendAuthorization: true,
    })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const listLocalSearch = async (filter: string): Promise<ILocal[]> => {
    if (filter === '') {
      filter = ' ';
    }

    const url = filter
      ? `${path}/search?perPage=300&currentPage=1&orderBy=code&orderDirection=asc&filter=${filter}`
      : `${path}/search?perPage=300&currentPage=1&orderBy=code&orderDirection=asc&filter= `;

    return await Subsidiary.getManyPaginated({
      path: url,
      sendAuthorization: true,
    })
      .then(result => {
        return result?.data;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const create = async ({ code, name }: ILocal): Promise<ILocal> => {
    return await Subsidiary.post({
      path: `${path}`,
      sendAuthorization: true,
      body: { code, name },
    })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const update = async (id: number, { code, name }: ILocal): Promise<ILocal> => {
    return await Subsidiary.put({
      path: `${path}/${id}`,
      sendAuthorization: true,
      body: { code, name },
    })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const remove = async (id: number): Promise<void> => {
    return await Subsidiary.remove({
      path: `${path}/${id}`,
      sendAuthorization: true,
    })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  return { list, listLocalByName, findById, listLocalBySubsidiaryId, listLocalSearch, create, update, remove };
};

export { useLocalService };
